import { useDispatch, useSelector } from 'react-redux'

import { fetchBarring } from './store/barring.reducer'
import { selectBarring, selectBarringLoading, selectBarringError } from './store/barring.selectors'

import { selectAgent } from '~/auth/store/auth.selectors'
import { useBrand } from '~/brand'

export default function useFetchBarring(subscriptionId: string) {
  const dispatch = useDispatch()
  const { brand } = useBrand()
  const { agent } = useSelector(selectAgent)

  return {
    getBarrings: (subscriptionId: string) =>
      dispatch(
        fetchBarring({
          subscriptionId,
          brand,
          sub: agent?.sub,
        }),
      ),
    barrings: useSelector(selectBarring(subscriptionId)),
    loading: useSelector(selectBarringLoading(subscriptionId)),
    error: useSelector(selectBarringError(subscriptionId)),
  }
}
